import React, {useState} from "react";
import {
  SlTabGroup,
  SlTab,
  SlTabPanel,
} from "@shoelace-style/shoelace/dist/react";
import DailyVsEenadu from "./DailyVsEenadu";
import EffortAnalysisReports from "./EffortAnalysisReports";
import MonthlyRevenue from "./MonthlyRevenue";
import MonthlyVsEenadu from "./MonthlyVsEenadu";
import DailyMissing from "./DailyMissing";
import OverallRevenue from "./OverallRevenue";
import SalesPersonReports from "./SalesPersonReports";
import AccountConversionRollingAverage from "./AccountConversionRollingAverage";

function SalesReports() {
  const [currentTab, setCurrentTab] = useState("dailyvseenadu");

  const handleTabChange = (tabName) => {
    setCurrentTab(tabName);
  };

  return (
    <>
      <h5>Sales Reports</h5>
      <SlTabGroup>
        <SlTab slot="nav" panel="dailyvseenadu" onClick={()=>{handleTabChange('dailyvseenadu')}}>Daily vs Eenadu</SlTab>
        <SlTab slot="nav" onClick={()=>{handleTabChange('monthlyvseenadu')}} panel="monthlyvseenadu">Monthly Vs Eenadu</SlTab>
        <SlTab slot="nav" panel="effortanalysis" onClick={()=>{handleTabChange('effortanalysis')}}>Effort Analysis</SlTab>
        <SlTab slot="nav" panel="dailymissing" onClick={()=>{handleTabChange('dailymissing')}}>Daily Missing</SlTab>
        <SlTab slot="nav" panel="overallrevenue" onClick={()=>{handleTabChange('overallrevenue')}}>Overall Revenue</SlTab>
        <SlTab slot="nav" panel="monthlyrevenue" onClick={()=>{handleTabChange('monthlyrevenue')}}>Monthly Revenue Report</SlTab>
        <SlTab slot="nav" panel="saleswise" onClick={()=>{handleTabChange('saleswise')}}>Sales Person Wise</SlTab>
        <SlTab slot="nav" panel="rollingaverage" onClick={()=>{handleTabChange('rollingaverage')}}>12 Month Rolling Average</SlTab>

        <SlTabPanel name="dailyvseenadu">
            {currentTab === 'dailyvseenadu' && <DailyVsEenadu />}
        </SlTabPanel>
        <SlTabPanel name="effortanalysis">
          {currentTab === 'effortanalysis' && <EffortAnalysisReports />}
          </SlTabPanel>
        <SlTabPanel name="monthlyrevenue">
          {currentTab === 'monthlyrevenue' && <MonthlyRevenue />}
          </SlTabPanel>
          <SlTabPanel name="monthlyvseenadu">
            {currentTab === 'monthlyvseenadu' && <MonthlyVsEenadu />}
          </SlTabPanel>
        <SlTabPanel name="dailymissing">
          {currentTab === 'dailymissing' && <DailyMissing/>}
        </SlTabPanel>
        <SlTabPanel name="overallrevenue">
            {currentTab === 'overallrevenue' && <OverallRevenue />}
        </SlTabPanel>
        <SlTabPanel name="saleswise">
            {currentTab === 'saleswise' && <SalesPersonReports />}
          </SlTabPanel>
        <SlTabPanel name="rollingaverage">
          {currentTab === 'rollingaverage' && <AccountConversionRollingAverage /> }
        </SlTabPanel>
      </SlTabGroup>
    </>
  );
}

export default SalesReports;
